var logger = {
    // This is a dummy logger, should be replaced with a proper logger in future.
    info: function (_errorMessage, _contextData) { },
    warn: function (_errorMessage, _contextData) { },
    error: function (_errorMessage, _contextData) { },
};

export { logger };
//# sourceMappingURL=logger.js.map
